import ContentPageEditPlain from "./Plain";
import ContentPageEditPolicy from "./Policy";
import ContentPageEditSupport from "./Support";
import "react-quill/dist/quill.snow.css";
import { Tabs } from "djinn-components";
import PageDetailsTab from "./Shared/Details";
import PageSettingsTab from "./Shared/Settings";
import ContentPageEditSupportSocialLinks from "./Support/SocialMediaLinks";
import ContentPageEditSupportForm from "./Support/FormSettings";
import ContentPageEditFeatures from "./Features";
import { PageType } from "../../types/api";

export interface ContentPageEditProps {
  page: PageType;
  reload: () => void;
}

const getPageComponent = (page: PageType, reload: () => void) => {
  switch (page.template) {
    case "support":
      return [
        {
          title: "Content",
          component: <ContentPageEditSupport {...{ page, reload }} />,
        },
        {
          title: "Social Media Links",
          component: (
            <ContentPageEditSupportSocialLinks {...{ page, reload }} />
          ),
        },
        {
          title: "Form",
          component: <ContentPageEditSupportForm {...{ page, reload }} />,
        },
      ];
    case "policy":
      return [
        {
          title: "Content",
          component: <ContentPageEditPolicy {...{ page, reload }} />,
        },
      ];
    case "features":
      return [
        {
          title: "Content",
          component: <ContentPageEditFeatures {...{ page, reload }} />,
        },
      ];
    default:
      return [
        {
          title: "Content",
          component: <ContentPageEditPlain {...{ page, reload }} />,
        },
      ];
  }
};

const ContentPageEdit: React.FC<ContentPageEditProps> = ({ page, reload }) => {
  return (
    <Tabs
      defaultActive={0}
      tabs={[
        {
          title: "Details",
          component: <PageDetailsTab {...{ page, reload }} />,
        },
        ...getPageComponent(page, reload),
        {
          title: "Settings",
          component: <PageSettingsTab {...{ page, reload }} />,
        },
      ]}
    />
  );
};

export default ContentPageEdit;
